export default __webpack_public_path__ + "static/media/Explorer_Logo.c6a4f1ad.svg";